import { Howl } from 'howler'
import { ease } from './helpers/EaseHelper'
/**
 * class Sound
 */
class Sound {
  /**
   * constructor
   */
  constructor (sound1, sound2, switchButton) {
    this.sounds = [new Howl({ src: sound1, loop: true }), new Howl({ src: sound2, loop: true, volume: 0 })]
    this.switchButton = switchButton
    this.isPlaying = false
    this._mix = 0 // from 0 to 1, 0 for sound 1, 1 for sound 2
    switchButton.addEventListener('click', () => this.toggle())
  }

  get mix () { return this._mix }

  set mix (value) {
    this._mix = value
    this.sounds[0].volume(1 - value)
    this.sounds[1].volume(value)
  }

  play () {
    const onPlay = (sound, index) => {
      const volume = (index < 1) ? (1 - this._mix) : this._mix
      this.switchButton.setAttribute('selected', '')
      this.isPlaying = true
      ease({ value: 0 })
        .to({ value: volume }, 500)
        .onUpdate(o => sound.volume(o.value))
        .start()
    }

    const playSound = (sound, index) => {
      sound.play()
      sound.muted = false
      sound.volume(0)
      onPlay(sound, index)
    }

    this.sounds.map(playSound)
  }

  stop () {
    const onStop = sound => {
      sound.stop()
      sound.muted = true
      this.switchButton.removeAttribute('selected')
      this.isPlaying = false
    }

    const stopSound = (sound, index) => {
      ease({ value: (index < 1) ? (1 - this._mix) : this._mix })
        .to({ value: 0 }, 500)
        .onUpdate(o => sound.volume(o.value))
        .onComplete(() => onStop(sound))
        .start()
    }

    this.sounds.map(stopSound)
  }

  toggle () {
    this.isPlaying ? this.stop() : this.play()
  }

  swap (index, duration) {
    ease(this)
    .to({ mix: index > 0 ? 1 : 0 }, duration)
    .start()
  }
}

export default Sound


// WEBPACK FOOTER //
// ./src/scripts/Sound.js